import classnames from 'classnames';
import type { ChangeEvent, FunctionComponent } from 'react';

import { Label } from '@/domains/productDiscovery/Listings/components/Filters/components/Label/Label';
import { Radio } from '@/domains/productDiscovery/Listings/components/Filters/components/newTamagoshiComponents/Radio/Radio';

import styles from './RadioSelectItem.module.scss';

interface Props {
  label: string;
  value: string;
  active?: boolean;
  className?: string;
  onClick?(event: ChangeEvent<HTMLInputElement>, label: string): void;
  id?: string;
  testId?: string;
  count?: number;
}

export const RadioSelectItem: FunctionComponent<Props> = ({
  className,
  label,
  value,
  active = false,
  onClick,
  id = 'default',
  testId = 'default',
  count,
}) => {
  const rootClassnames = classnames(styles.root, className);

  const handleClick = (event: ChangeEvent<HTMLInputElement>) => {
    if (onClick) {
      onClick(event, value);
    }
  };

  return (
    <Radio
      className={rootClassnames}
      id={`${id}-${value}`}
      isChecked={active}
      value={value}
      onChange={handleClick}
      testId={`RadioSelectItem-${testId}-${value}`}
    >
      <Label label={label} count={count || undefined} active={active} />
    </Radio>
  );
};

RadioSelectItem.displayName = 'RadioSelectItem';
